import { useEffect } from "react";
import { SITE_URL, BUSINESS } from "../data/site";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Base Organization / LocalBusiness schema reused across the site
export const orgSchema = {
  "@context": "https://schema.org",
  "@type": ["Organization", "LocalBusiness", "GeneralContractor", "HomeAndConstructionBusiness"],
  name: BUSINESS.name,
  description: BUSINESS.description,
  url: SITE_URL,
  logo: BUSINESS.logo,
  image: BUSINESS.logo,
  email: BUSINESS.email,
  telephone: BUSINESS.phones[0],
  address: { "@type": "PostalAddress", addressRegion: "FL", addressCountry: "US" },
  areaServed: BUSINESS.counties.map((c) => ({ "@type": "AdministrativeArea", name: `${c}, Florida` })),
  knowsAbout: ["Custom Home Builder", "Custom Homes", "Custom Home Design", "Custom Home Construction", "Build on Your Lot"],
};

const Seo = ({
  title,
  description,
  path = "/",
  image = BUSINESS.logo,
  keywords,
  schema,
  breadcrumbs,
}) => {
  useEffect(() => {
    const url = `${SITE_URL}${path === "/" ? "" : path}`;
    const fullTitle = title || `${BUSINESS.name} | ${BUSINESS.tagline}`;
    document.title = fullTitle;

    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertLink("canonical", url);

    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", image);
    upsertMeta("property", "og:site_name", BUSINESS.name);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    // JSON-LD
    const graph = [orgSchema, {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: BUSINESS.name,
      url: SITE_URL,
    }];
    if (schema) graph.push(schema);
    if (breadcrumbs && breadcrumbs.length) {
      graph.push({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: `${SITE_URL}${b.path === "/" ? "" : b.path}`,
        })),
      });
    }
    let script = document.getElementById("ld-json");
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "ld-json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(graph);
  }, [title, description, path, image, keywords, schema, breadcrumbs]);

  return null;
};

export default Seo;
